import { AgGridReact } from "ag-grid-react"
import { useAgGrid } from "../PortfolioManagement/components/hooks/useAgGrid"
import { TableSection } from "./types"
import { TableContainer } from "./Warren.styled"

const TableSectionComponent = ({ section }: { section: TableSection }) => {
  const {
    gridRef,
    gridOptions: { columnDefs },
  } = useAgGrid({
    columns: section?.columnDefs || [],
    columnSizingStrategy: "sizeToFit",
  })

  if (!section) {
    console.error("TableSectionComponent received undefined section")
    return null
  }

  if (!section.columnDefs || !Array.isArray(section.columnDefs)) {
    console.error("TableSectionComponent section missing columnDefs:", section)
    return <div>Error: Invalid table data</div>
  }

  return (
    <TableContainer className="ag-theme-balham-dark">
      <AgGridReact ref={gridRef} rowData={section.rowData || []} columnDefs={columnDefs} />
    </TableContainer>
  )
}

export default TableSectionComponent
